import { render, staticRenderFns } from "./ButtonLinkWrapper.vue?vue&type=template&id=a39a10ee&"
import script from "./ButtonLinkWrapper.vue?vue&type=script&lang=js&"
export * from "./ButtonLinkWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports